module.exports = __webpack_public_path__ + "img/product_02_pic@2x.b8d7b19b.png";